export default __webpack_public_path__ + "static/media/241.ac8de9c9.jpg";